module.exports = __webpack_public_path__ + "static/img/minapp_qw.cba6895.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/minapp_qw.jpg
// module id = wJJa
// module chunks = 0